module.exports = __webpack_public_path__ + "static/media/bottle.aaa4189b.svg";